module.exports = __webpack_public_path__ + "img/unicef.7b276a7f.svg";